import "./Page.styl";

import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import Match from "../components/Match";

import { Container, Row, Col } from "reactstrap";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

class Page extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    const { googleMapsApiKey, pathname } = this.props;

    const seoTitle = "Dodaj Ogłoszenie poprzez Lockstep ERP";
    const seoDescription =
      "Chciałbyś dodawać ogłoszenia do naszego portalu? Jeżeli posiadasz system Lockstep, możesz to robić za darmo!";

    return (
      <div className="lockstep-page">
        <Helmet
          title={seoTitle}
          description={seoDescription}
          meta={[
            { name: "description", content: seoDescription },
            { property: "og:type", content: "website" },
            { property: "og:title", content: seoTitle },
            { property: "og:description", content: seoDescription },
            {
              property: "og:image",
              content: "https://opiekujsie.pl/static/lockstep.jpg"
            }
          ]}
        />
        <Header />

        <div className="lockstep-section">
          <div className="lockstep-wrapper">
            <div className="image" />
            <div className="content">
              <h1 className="title">Lockstep ERP</h1>
              <div className="link">
                <a href="https://lockstep.pl" target="_blank">
                  https://lockstep.pl
                </a>
              </div>
              <div className="description">
                Nasze oferty pracy pobierane są bezpośrednio z systemu dla{" "}
                <span> Agencji Opiekunek Osób Starszych.</span>
              </div>
              <div className="text margin">
                Rozliczenie za system odbywa się w formie płatności miesięcznej.
              </div>
              <div className="text margin">
                <span>Zapraszamy do kontaktu:</span>
              </div>
              <div className="text">Marcin Pastuszek</div>
              <div className="text">tel. 882 153 932</div>
              <div className="text">marcinpastuszek@lockstep.pl</div>
              <a
                className="btn btn-secondary btn-lg margin"
                href="https://lockstep.pl/?kontakt"
                target="_blank"
              >
                JESTEM ZAINTERESOWANY!
              </a>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

Page.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(state => ({}), {})(Page);



/** WEBPACK FOOTER **
 ** ./src/browser/lockstep/Page.js
 **/